import * as types from './BUMAction_Types'
import { updateAlertError, updateLoader } from '../common/common_action'
import { GetRequest, GetRequestCached, GetRequestCachedV3, PostRequest, PostRequestCachedV3, PostRequestV2 } from '../../components/common/api'
import { urls } from '../../components/common/constants'


export const updateUserRollRightTable = (data) => {
  return { type: types.USERROLLRIGHT_TABLEDATA, data }
}
export const updateBranchDetails = (data) => {
  return { type: types.BRANCH_DETAILS, data }
}
export const updateModalHeaderDropDownData = (data) => {
  return { type: types.UPDATE_MODAL_HEADER_DROPOWN, data }
}
export const updateUserMasterTable = (data) => {
  return { type: types.USER_MASTER_TABLEDATA, data }
}
export const updateAutoDeactivateUsers = (data) => {
  return { type: types.AUTO_DEACTIVATE_USER_TBLDATA, data }
}
export const updateADUCategoty = (data) => {
  return { type: types.ADU_CATEGORY_DATA, data }
}

export const updateMacRequestsTableData = (data) => {
  return { type: types.MAC_REQUESTS_TABLE_DATA, data }
}
export const updateMacAuthenticationTableData = (data) => {
  return { type: types.MAC_AUTH_TABLE_DATA, data }
}
export const updateMavenMgmtTblData = (data) => {
  return { type: types.MAVEN_MGMT_TABLE_DATA, data }
}
export const updateMacMgmtTableData = (data) => {
  return { type: types.MAC_MGMT_TABLE_DATA, data }
}
export const updateMacBranchDetailsTableData = (data) => {
  return { type: types.BRANCH_MAC_DETAILS, data }
}
export const updateBranCommissionForAll = (data) => {
  return { type: types.BRANCH_COMMISSION_FOR_ALL, data }
}
export const getUserMasterTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequest(urls.getUserMasterTableData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateUserMasterTable(res.Data))
      } else {
        dispatch(updateUserMasterTable([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateUserMasterTable([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const getUserRollRightTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getUserRollRightTblData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateUserRollRightTable(res.Data))
      } else {
        dispatch(updateUserRollRightTable([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: 'URRCatagory' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateUserRollRightTable([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}

export const getBranchDetails = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateBranchDetails(res?.Data?.Table || []))
      } else {
        dispatch(updateBranchDetails([]))
        dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: 'status' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateBranchDetails([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: 'status' }))
    })
}

export const getStateList = (obj, isCache = false, cacheDuration = 0) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequestCachedV3(urls.getNearStateList, obj, isCache, cacheDuration)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getCityList = (obj, isCache = false, cacheDuration = 0) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequestCachedV3(urls.getCitiesListAll, obj, isCache, cacheDuration)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const saveBranchDetails = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.saveBranchDetails, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getBranchData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getBranchConfigOrEwbillinfo, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const updateBranchBusData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateBranchBusData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getGSTNValidation = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.validateGSTN, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const updateBranchReportData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateBranchReportData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getBranchDirectoryData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getBranchDirectoryData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const updateBrnhDirectoytData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateBrnhDirectoytData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getBranchCommission = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getBranchCommission, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const updateBrnhCargotData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateBranchCargoConfig, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}


export const getBranchMaster = (companyID) => (dispatch) => {
  const body = {
    intUserID: 0,
    intCompanyID: companyID,
    intBranchID: 0,
    strBranchName: "",
    strBranchCode: "",
    intStateID: 0,
    intCityID: 0,
    intIsActive: -1
  }
  PostRequest(urls.getBranchConfigOrEwbillinfo, body)
    .then((res) => {
      if (res.status === 'Success') {
        dispatch(updateBranchDetails(res?.Data?.Table || []))
      } else {
        dispatch(updateBranchDetails([]))
      }
    })
    .catch((error) => {
      dispatch(updateBranchDetails([]))
    })
}
export const getAllBranchName = (obj, isCache = false, cacheDuration = 0) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, obj, isCache, cacheDuration)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getAllDriverConductor = (obj, isCache = false, cacheDuration = 0) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequestCachedV3(urls.getDriverList, obj, isCache, cacheDuration)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const verifyPanNumber = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.verifyPanNumber, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getRollRights = (obj, isCache = false, cacheDuration = 0) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequestCachedV3(urls.getUserRoleRights, obj, isCache, cacheDuration)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const addNewUser = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.addNewUser, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const addNewUserV2 = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.addNewUserV2, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getEditUser = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getEditUser, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const userRollRightEditRights = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getUserRollRightEditRight, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const userRREditRightsSave = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getUserRREditRightSave, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const userRRAddUser = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getUserRRAddUser, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const userRRCashBookRights = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getRoleRightsSetting, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const userRRCashBookRightsSave = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getUserRRCashBookRightsSave, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const userRRLuggageBookRightsSave = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getUserRRLuggageBookRightsSave, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const userRRBookAcSpecialRights = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    GetRequest(urls.getUserRRBookAcSpecialRights, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const userRRBookAcSpecialRightsSave = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getUserRRBookAcSpecialRightsSave, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const userRRARBookAcSpecialRightsSave = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getUserRRARBookAcSpecialRightsSave, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const userRRQTBookAcSpecialRightsSave = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getUserRRQTBookAcSpecialRightsSave, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const userRRSpecialRightsSave = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getUserRRSpecialRightsSave, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getAutoDeactivateUserTblData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getAutoDeactivateUsersData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateAutoDeactivateUsers(res?.Data?.Table))
      } else {
        dispatch(updateAutoDeactivateUsers([]))
        // dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateAutoDeactivateUsers([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}
export const getADUCategoryData = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequestCachedV3(urls.getAutoDeactivateUsersData, data, isCache, cacheDuration)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateADUCategoty(res?.Data?.Table))
      } else {
        dispatch(updateADUCategoty([]))
        // dispatch(updateAlertError({ show: true, msg: 'No Data', nextId: '' }))
      }
    })
    .catch((error) => {
      dispatch(updateLoader(false))
      dispatch(updateADUCategoty([]))
      dispatch(updateAlertError({ show: true, msg: error, nextId: '' }))
    })
}
export const updateAutoDeactivateUserData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateADUTblData, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getMacRequestsTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getMacRequests, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status == 'Success') {
        dispatch(updateMacRequestsTableData(res))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const getMacRequestAcceptReject = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getMacRequestAcceptReject, data)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getMacAuthenticationTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getMacAuthTableData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateMacAuthenticationTableData(res?.Data?.Table))
      } else {
        // dispatch(updateMacAuthenticationTableData([]))
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const updateMacAssign = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getMacAuthUpdateAssign, data)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getMacManagementTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getMacRequests, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateMacMgmtTableData(res?.Data?.Table))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const getMavenMgmtTblData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getMavenManagementTableData, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateMavenMgmtTblData(res?.Data))
      } else {
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: 'mvnMgmtBranchName' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const updateMacManagementStatus = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getMacMgmtActiveDeactive, data)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const updateMavenUsersData = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequestV2(urls.updateMavenUsers, data)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const updateOtherCargoBranchCofigData = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.branchCargoConfigUpdate, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getBranchDetailsInfo = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.getBranchConfigOrEwbillinfo, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}

export const getBranchMacDetailsTableData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.GetBranchMacDetails, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateMacBranchDetailsTableData(res?.Data?.Table))
      } else {
        dispatch(updateMacBranchDetailsTableData([]))
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}

export const updateBranchMacAddress = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequest(urls.updateBranchMacAddress, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const getBranchCommissionForAllData = (data) => (dispatch) => {
  dispatch(updateLoader(true))
  GetRequest(urls.getBranchCommissionForAll, data)
    .then((res) => {
      dispatch(updateLoader(false))
      if (res.status === 'Success') {
        dispatch(updateBranCommissionForAll(res?.Data?.Table))
      } else {
        dispatch(updateBranCommissionForAll([]))
        dispatch(updateAlertError({ show: true, msg: res.ErrMessage, nextId: '' }))
      }
    })
    .catch((err) => {
      dispatch(updateLoader(false))
    })
}
export const deleteInactiveBranches = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequestV2(urls.deleteInactiveBranches, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}
export const deleteInactiveUsers = (obj) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateLoader(true))
    PostRequestV2(urls.deleteInactiveUsers, obj)
      .then((res) => {
        dispatch(updateLoader(false))
        return resolve(res)
      })
      .catch((error) => {
        dispatch(updateLoader(false))
        reject(error)
      })
  })
}